import React, { useEffect } from 'react';
import Modal from '@mui/material/Modal';
// import { appInsights, reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import cn from 'clsx';
import { TextComponent, SelectComponent } from '../../uiComponents';
import Button from '@mui/material/Button';
import { useSelector, useDispatch } from 'react-redux';
import { getJSONTemplates, fetchTemplate, setJSONEditor, getSessionId } from '../../../store';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { SelectChangeEvent } from '@mui/material/Select';
import { JSONTemplate, OptionProps } from '../../../view-models';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TemplateOptionsComponent from '../templateGenerator/templateOptions';
import { getActiveDefaultEnvironments, getMigratedJson } from '../utils';
import jsonConstants from '../../../constants/jsonConstants';
import defaultEnvs from '../../../constants/defaultEnvs';
// import { sendAIAnalyticsTrace } from '../utils';
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const styles1 = makeStyles((theme: Theme) =>
  createStyles({
    alignItems: {
      alignItems: 'flex-start',
    },
    baseAlign: {
      alignItems: 'baseline',
    },
    centerAlign: {
      alignItems: 'center',
    },
    new: {
      backgroundColor: '#900603',
      color: '#ffffff',
      padding: '10px',
      marginLeft: 10,
      borderRadius: 5,
    },
    submitButton: {
      marginLeft: 20,
    },
    divider: {
      borderBottom: '1px solid grey',
      marginLeft: 10,
      marginRight: 10,
      flex: 1,
    },
    dividerContainer: {
      paddingTop: '10px',
      paddingBottom: '10px',
    },
    templatesList: {
      width: '100%',
    },
    mt50: {
      marginTop: 50,
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
    },
  }),
);
interface CreateNewUserJourneyProps {
  existingFCNames: string[];
  handleClose: any;
}

const CreateNewUserJourney = ({ existingFCNames, handleClose }: CreateNewUserJourneyProps) => {
  const classes: any = jsonEditorStyles();
  const classes1 = styles1();
  const dispatch = useDispatch();
  const [name, setName] = React.useState<string>('');
  const [error, setError] = React.useState<string>('Name cannot be empty');
  const [templateGroup, setTemplateGroup] = React.useState<any>({});
  const [selectedTemplateGroup, setSelectedTemplateGroup] = React.useState<string>('');
  const [selectedTemplate, setSelectedTemplate] = React.useState<any>({});
  const [templateDesc, setTemplateDesc] = React.useState<string>('');
  const [templateVideo, setTemplateVideo] = React.useState<string>('');
  const jsonTemplates = useSelector(getJSONTemplates);

  const [selectedTab, setSelectedTab] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    setSelectedTemplateGroup(Object.keys(templateGroup)[0]);
  }, [templateGroup]);

  useEffect(() => {
    if (
      templateGroup &&
      templateGroup.hasOwnProperty(selectedTemplateGroup) &&
      templateGroup[selectedTemplateGroup].length > 0
    ) {
      setSelectedTemplate(templateGroup[selectedTemplateGroup][0]);
    }
  }, [selectedTemplateGroup]);

  useEffect(() => {
    setTemplateDesc(selectedTemplate['helpText'] || '');
    setTemplateVideo(selectedTemplate['videoLink'] || '');
  }, [selectedTemplate]);

  useEffect(() => {
    const temp = jsonTemplates.reduce(
      (groups: any, item: JSONTemplate) => ({
        ...groups,
        [item.categoryName]: [...(groups[item.categoryName] || []), item],
      }),
      {},
    );
    setTemplateGroup(temp);
    Object.keys(temp).length > 0 && setSelectedTemplateGroup(Object.keys(templateGroup)[0]);
  }, [jsonTemplates]);

  const Input = styled('input')({
    display: 'none',
  });

  const handleFileInput = (target: EventTarget & HTMLInputElement) => {
    console.log('User uploaded policy json');
    // sendAIAnalyticsTrace('User uploaded policy json', 'uploadJson', { sessionId: sessionId });
    // @ts-ignore
    Promise.all([target.files?.item(0).text()]).then((values: any) => {
      let parsedJson = JSON.parse(values);
      if (parsedJson.jsonSchemaVersion !== jsonConstants.editorJsonSchemaVersion) {
        window.alert("Could not upload - JSON schema version out of date. Contact Grit for support in updating JSON to the current editor version.");
      } else {
        if (Object.keys(parsedJson.templatization.environments).length === 0) {
          parsedJson.templatization.environments = getActiveDefaultEnvironments();
        } else if (jsonConstants.injectDevEnvWhenEnabled && jsonConstants.enableGritDevEnvDefaultEnv && (!Object.keys(parsedJson.templatization.environments).includes(jsonConstants.defaultEnvMap['enableGritDevEnvDefaultEnv']))) {
          // Inject the dev environment if it is enabled.
          const devEnvId = jsonConstants.defaultEnvMap['enableGritDevEnvDefaultEnv'];
          parsedJson.templatization.environments[devEnvId] = getActiveDefaultEnvironments()[devEnvId];
        }
        dispatch(setJSONEditor(parsedJson));
        handleClose('upload', null);
      }
    });
  };

  const customiseLabel = () => {
    return (
      <div className={cn(classes.flexRow, classes1.centerAlign)}>
        <div>Customize User Journey</div>
        <div className={classes1.new}>New Feature</div>
      </div>
    );
  };

  return (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose('close', null);
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={classes.modalStyle}
    >
      <div className={classes.smallPopup}>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={selectedTab} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Load/Create User Journey" {...a11yProps(0)} />
              <Tab label={customiseLabel()} {...a11yProps(1)} />
            </Tabs>
          </Box>
          <TabPanel value={selectedTab} index={0}>
            <div className={cn(classes.flexCol, classes.policyBody)}>
              <div className={classes1.flexRow}>
                {Object.keys(templateGroup).length > 0 && (
                  <SelectComponent
                    changeHandler={(e: SelectChangeEvent<string>) => {
                      setSelectedTemplateGroup(e.target.value);
                    }}
                    data={{
                      value: selectedTemplateGroup || '',
                      label: 'Select a Template Group',
                      style: { margin: 1, width: 250 },
                      options: Object.keys(templateGroup).reduce(
                        (acc: OptionProps[], groupName: string) => acc.concat({ label: groupName, value: groupName }),
                        [],
                      ),
                    }}
                  />
                )}
                {templateGroup.hasOwnProperty(selectedTemplateGroup) && (
                  <>
                    <SelectComponent
                      changeHandler={(e: SelectChangeEvent<string>) => {
                        setSelectedTemplate(
                          templateGroup[selectedTemplateGroup].filter(
                            (template: any) => template['fileName'] === e.target.value,
                          )[0],
                        );
                      }}
                      data={{
                        value: selectedTemplate['fileName'] || '',
                        label: 'Select a Template',
                        style: { margin: 1, flex: 1 },
                        options: templateGroup[selectedTemplateGroup].reduce(
                          (acc: OptionProps[], template: any) =>
                            acc.concat({ label: template['displayName'], value: template.fileName }),
                          [],
                        ),
                      }}
                    />
                  </>
                )}
              </div>

              {Object.keys(selectedTemplate).length > 0 && (
                <>
                  <span style={{ margin: '0 10px 10px 10px', fontSize: 14, fontStyle: 'italic' }}>
                    {templateDesc !== '' && <>{templateDesc}</>}
                    {templateVideo !== '' && (
                      <>
                        {' '}
                        <a href={templateVideo} target="_blank">
                          Click here to see the video
                        </a>
                      </>
                    )}
                  </span>

                  <div className={classes1.flexRow} style={{ margin: '0 0 0 10px' }}>
                    {selectedTemplate['comingSoon'] ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          console.log('Vote a template :', selectedTemplate['fileName']);
                          // sendAIAnalyticsTrace('Vote a template', 'voteTemplate', {
                          //   sessionId: sessionId,
                          //   template: selectedTemplate['fileName'],
                          // });
                        }}
                      >
                        Vote for this template
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={!selectedTemplate['fileName'] || selectedTemplate['comingSoon']}
                        onClick={() => {
                          console.log('User selected a template :', selectedTemplate['fileName']);
                          // sendAIAnalyticsTrace('User selected a template', 'selectTemplate', {
                          //   sessionId: sessionId,
                          //   template: selectedTemplate['fileName'],
                          // });
                          dispatch(fetchTemplate(selectedTemplate['fileName']));
                          handleClose('template', null);
                        }}
                      >
                        Load Template
                      </Button>
                    )}
                  </div>
                </>
              )}
            </div>

            <div className={cn(classes1.flexRow, classes1.baseAlign)}>
              <div className={classes1.divider}></div>
              <div> or </div>
              <div className={classes1.divider}></div>
            </div>
            <div className={cn(classes1.flexRow, classes.policyBody, classes1.alignItems)}>
              <div className={classes1.submitButton}>
                <label htmlFor="policyUpload">
                  <Input
                    type="file"
                    name="policyUpload"
                    id="policyUpload"
                    accept=".json"
                    onChange={(e: { target: EventTarget & HTMLInputElement }) => {
                      e.target.files !== null && e.target.files.length !== 0 && handleFileInput(e.target);
                      e.target.value = '';
                    }}
                  />
                  <Button component="span">Upload JSON</Button>
                </label>
              </div>
            </div>
            <div className={cn(classes1.flexRow, classes1.baseAlign)}>
              <div className={classes1.divider}></div>
              <div> or </div>
              <div className={classes1.divider}></div>
            </div>
            <div className={cn(classes1.flexRow, classes.policyBody, classes1.alignItems)}>
              <TextComponent
                changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                  setName(e.target.value);
                  if (e.target.value.trim() === '') {
                    setError('Name cannot be empty');
                  } else if (existingFCNames.includes(e.target.value)) {
                    setError('A flowchart exists with the same name');
                  } else {
                    setError('');
                  }
                }}
                data={{
                  value: name,
                  label: 'New Flowchart Name',
                  error: !!error,
                  style: { margin: 0, width: 300 },
                  helperText: error,
                }}
              />
              <div className={classes1.submitButton}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!!error}
                  onClick={() => {
                    console.log('Usercreated a new flowchart :', name);
                    // sendAIAnalyticsTrace('User created a new flowchart', 'newChart', { sessionId: sessionId });
                    handleClose('createNew', name);
                  }}
                >
                  Create
                </Button>
              </div>
            </div>
            <div className={cn(classes1.flexRow, classes1.baseAlign)}>
              <div className={classes1.divider}></div>
              <div> or </div>
              <div className={classes1.divider}></div>
            </div>
            <div className={cn(classes1.flexRow, classes.policyBody, classes1.alignItems)}>
              <Button
                variant="contained"
                color="primary"
                disabled={!selectedTemplate['fileName'] || selectedTemplate['comingSoon']}
                onClick={() => {
                  window.open('./xmlEditor', '_blank');
                }}
              >
                View / Edit IEF XML
              </Button>
            </div>
            <footer className={cn(classes.footer, classes1.mt50)}>
              <Button
                variant="contained"
                color="error"
                disabled={existingFCNames.length === 0}
                onClick={() => {
                  handleClose('cancel', null);
                }}
              >
                Cancel
              </Button>
            </footer>
          </TabPanel>
          <TabPanel value={selectedTab} index={1}>
            <TemplateOptionsComponent
              handleClose={(options: any) => {
                handleClose('templateBuilder', options);
              }}
            />
          </TabPanel>
        </Box>
      </div>
    </Modal>
  );
};

// export default withAITracking(reactPlugin, CreateNewUserJourney);
export default CreateNewUserJourney;
